import axios from '../../service/index'
import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import E from 'wangeditor'
import { Button, Divider,  message, Form } from 'antd'

import './inductionManage.less'
let qiniuUpUrl = 'https://up-z1.qiniup.com'
class inductionManageDetails extends Component {
  state = {
    des: '',
    typeTitel:'add',
    subjectId: '',
    token: '',
  }
  componentDidMount() {
    this.getToken()
    let {typeTitel, subjectId} = this.props.location.state
    this.setState({typeTitel, subjectId}, () => {
      if(this.state.typeTitel === 'edit'){
        this.inductionManageDetail()
      }
    })
    let editor = new E(ReactDOM.findDOMNode(this._div))
		this.setState({ editor: editor })
		editor.config.menus = [
			'head',
			'bold',
			'fontSize',
			'fontName',
			'italic',
			'underline',
			'strikeThrough',
			'indent',
			'lineHeight',
			'foreColor',
			'backColor',
			'link',
			'list',
			'todo',
			'justify',
			'quote',
			'table',
			'splitLine',
			'undo',
			'redo',
			'image',
		]
		editor.config.uploadImgMaxLength = 5;
		editor.config.showLinkImg = false;
		editor.config.uploadImgServer = "/upload"; //上传图片的server接口地址
		editor.config.withCredentials = false;
		editor.config.uploadImgTimeout = 5 * 1000;
		let _this = this
    editor.config.customUploadImg = function (resultFiles, insertImgFn) {
			let imgUrl = ''
			let data = new FormData();
			data.append("token", _this.state.token);
			data.append("file", resultFiles[0]);
			axios({
				method: "POST",
				url: qiniuUpUrl,
				data: data,
				onUploadProgress: function (progressEvent) {
				},
			}).then((res) => {
				imgUrl = _this.state.url + '/' + res.data.key
				insertImgFn(imgUrl);
			});
		};
		editor.config.onchange = (html) => {
			this.setState({
				editorHtml: html,
				editorText: editor.txt.text()
			})
			//将html值设为form表单的desc属性值
			this.props.form.setFieldsValue({
				'des': html
			});
		}
    editor.create()
  }
  getToken=() =>{
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}
		}).catch((e) => {
			console.log(e)
		})
	}
  inductionManageDetail() {
    axios.get(`/testQuestionc/infoByQuestionId/${this.state.subjectId}`).then(res => {
      if (+res.data.code === 200) {
        if (res.data.data) {
          this.setState({infoObj: res.data.data},() => {
            this.state.editor.txt.html(this.state.infoObj.des)
          })
        }
    }
    })
  }
  submitOk = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if(!err) {
        let params = {
          des: values.des,
          subjectId: this.state.subjectId
        }
        let url = 'testQuestionc/updateByQuestionId'
        axios.post(url, params).then(res => {
          if(+res.data.code !== 200)return message.error(res.data.msg)
          this.props.form.resetFields()
          this.state.editor.txt.html('<p><br></p>')
          message.success('编辑成功')
          this.props.history.push('/inductionManage',{subjectId: this.state.subjectId})
        })
      }
    })
  }
  handleReset = () => {
    let {subjectId} = this.state
    this.props.form.resetFields();
    this.state.editor.txt.html('<p><br></p>')
    this.props.history.push('/inductionManage',{subjectId})
  }
  render() {
    let { typeTitel, subjectId} = this.state
    const { getFieldDecorator } = this.props.form;
    const tailLayout = {
      wrapperCol: { offset: 3, span: 12 },
    }
    return (
      <div className="modal-pack">
        <div className="header-between">
          <span className="header-name">编辑入门测</span>
          <span className="my-button-txt" onClick={()=>{
              this.props.history.push('/inductionManage',{subjectId})
            }}>返回上一级</span>
          </div>
				<Divider />
          <Form labelCol={{ span: 3 }} wrapperCol={{ span: 12 }} onSubmit={this.submitOk}>
            <Form.Item label="入门测详情">
              {getFieldDecorator('des', {
              rules: [
                {required: true, message: '请输入入门测详情'}
              ],
              initialValue: typeTitel === 'edit' ? '' : ''
            })(
							<div ref={(ref) => this._div = ref}></div>
						)}
						</Form.Item>
            <Form.Item {...tailLayout}>
            <Button  onClick={this.handleReset}>
              取消
            </Button>
            <Button style={{ marginLeft: 8 }} type="primary" htmlType="submit">
              确定
            </Button>
						</Form.Item>
					</Form>
      </div>
    )
  }
}
export default Form.create()(inductionManageDetails)
